import React from 'react';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import RenderNode from '../../components/rich-text/render-node';
import RichTextAssembly from '../../components/assemblies/rte';

export const getClosePoint = (segment = '', init = 0) => {
  const open = segment.indexOf('[');
  const close = segment.indexOf(']');
  if (close < open || open === -1 || close === -1) return close + init;
  return getClosePoint(segment.slice(close + 1), close + init + 1);
};

/* ************************************************************
 *
 * divideText
 * It substitutes a simple regex expression to find recursively
 * nested square parentesis.
 *
 * this way citations like [Jones and al. [1989]] are processed
 * correctly
 *
 * @param {string[]} text - is an array containing the string
 * to process
 * @returns {string[]} - returns the string splitted into text and
 * citation blocks
 *
 * ********************************************************** */
export const divideText = (text = []) => {
  if (!text.length || text.length === 0) return text;
  const isEven = text.length % 2 === 0;
  // eslint-disable-next-line no-use-before-define
  return splitter(text, !isEven);
};

export const composeDivision = (text = [], segment = '', splitPoint = -1) =>
  divideText([
    ...text.slice(0, -1),
    segment.slice(0, splitPoint),
    segment.slice(splitPoint + 1),
  ]);

export const splitter = (text = [], start = true) => {
  const segment = text[text.length - 1];
  const splitPoint = start ? segment.indexOf('[') : getClosePoint(segment);
  if (splitPoint === -1) return text;
  return composeDivision(text, segment, splitPoint);
};

export const handleBracketsInRichText = (
  rawText,
  count,
  updateReferenceList,
  updateCount
) => {
  const textWithMatches = divideText([rawText]);

  if (textWithMatches.length > 1) {
    // Rich text formats in paragraph chunks, set to count to account for preceding footnotes
    let countToShow = count;

    for (let i = 1; i < textWithMatches.length; i += 2) {
      countToShow += 1;
      // Push text to reference list so we can later render the footnotes list
      updateReferenceList(textWithMatches[i]);
      textWithMatches[i] = (
        <a
          id={`source-${countToShow}`}
          href={`#reference-${countToShow}`}
          key={i}
        >
          [{countToShow}]
        </a>
      );
    }
    // Update the count so the next rich text knows the count to start from
    updateCount(countToShow);
  }

  return textWithMatches;
};
export default handleBracketsInRichText;

/**
 * Takes an array of content
 * The RichText is modified if square brackets are detected and the
 * modified content along with an array of generated footnotes are returned
 *
 * @param {{title, textContent}[]} tableOfContents
 */
export const createFootnotes = (tableOfContents) => {
  if (!tableOfContents) return [null, null];

  const footnotes = [];
  const pushToFootnotes = (text) => {
    footnotes.push(text);
  };
  let foundFootnotesCount = 0;
  const updateFootnotesCount = (count) => {
    foundFootnotesCount = count;
  };

  const modifiedContent = tableOfContents.reduce((acc, content) => {
    const richText = content.textContent;
    const renderedModifiedRichText = renderRichText(
      richText,
      RenderNode({}, RichTextAssembly, (text) =>
        handleBracketsInRichText(
          text,
          foundFootnotesCount,
          pushToFootnotes,
          updateFootnotesCount
        )
      )
    );
    const updatedContent = { ...content };
    updatedContent.textContent = renderedModifiedRichText;
    acc.push(updatedContent);
    return acc;
  }, []);

  return [modifiedContent, footnotes];
};
